export class SplunkLogEvent {
  message: string;
  severity = 'info';
  constructor(log = null) {
    if (log) {
      this.message = (log.message) ? (log.message) : this.message;
      this.severity = (log.severity) ? (log.severity) : this.severity;
    }
  }
}
